import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useSelectedPropertyId } from '../../../store/propertyStore'
import { shiftService } from '../services/shiftService'
import { PREVIOUS_SHIFTS_QUERY_KEY } from '../constants/handoverConstants'
import type { ShiftResponse } from '../types/shift.types'

export function usePreviousShifts(): UseQueryResult<ShiftResponse[]> {
  const propertyId = useSelectedPropertyId()
  return useQuery<ShiftResponse[]>({
    queryKey: [PREVIOUS_SHIFTS_QUERY_KEY, { propertyId }],
    queryFn: async () => {
      const page = await shiftService.list(propertyId as number, 10)
      return page.shifts.filter((s) => s.ended_at !== null)
    },
    enabled: propertyId !== null,
    meta: { silent: true, source: 'usePreviousShifts' },
  })
}
